"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadMissingData = void 0;
var tslib_1 = require("tslib");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeFilterUtils_1 = require("../../utils/AttributeFilterUtils");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var prepareElementsQuery = function (backend, workspace, filterObjRef, parentFilters, parentFilterOverAttribute, offset, limit, searchQuery) {
    var preparedElementQuery = backend
        .workspace(workspace)
        .attributes()
        .elements()
        .forDisplayForm(filterObjRef)
        .withOptions(tslib_1.__assign({}, (!isEmpty_1.default(searchQuery) ? { filter: searchQuery } : {})))
        .withOffset(offset)
        .withLimit(limit);
    if (AttributeFilterUtils_1.isParentFilteringEnabled(backend)) {
        if (parentFilters && !AttributeFilterUtils_1.isParentFiltersElementsByRef(parentFilters)) {
            // eslint-disable-next-line no-console
            console.error("Parent filters must be defined by uris to enable parent-child filtering feature");
        }
        else {
            preparedElementQuery.withAttributeFilters(AttributeFilterUtils_1.getValidElementsFilters(parentFilters, parentFilterOverAttribute));
        }
    }
    return preparedElementQuery;
};
/**
 * Fetches missing attribute elements on scrolling.
 */
exports.useLoadMissingData = function (props) {
    var context = props.context, state = props.state, ownProps = props.ownProps, onLoadMissingDataSuccess = props.onLoadMissingDataSuccess;
    var promise = AttributeFilterUtils_1.needsLoading(state.validOptions, state.offset, state.limit) || state.needsReloadAfterSearch
        ? function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var preparedElementQuery;
            return tslib_1.__generator(this, function (_a) {
                preparedElementQuery = prepareElementsQuery(context.backend, context.workspace, context.filterObjRef, ownProps.parentFilters, ownProps.parentFilterOverAttribute, state.offset, state.limit, state.searchString);
                return [2 /*return*/, preparedElementQuery.query()];
            });
        }); }
        : null;
    return sdk_ui_1.useCancelablePromise({
        promise: promise,
        onSuccess: function (newElements) {
            onLoadMissingDataSuccess(newElements, ownProps.parentFilters, ownProps.isElementsByRef);
        },
    }, [
        state.selectedFilterOptions,
        state.appliedFilterOptions,
        state.validOptions,
        state.offset,
        state.limit,
        state.searchString,
        state.needsReloadAfterSearch,
        ownProps.parentFilters,
    ]);
};
//# sourceMappingURL=useLoadMissingData.js.map